import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';

@Pipe({
  name: 'deviceStatus'
})
export class DeviceStatusPipe implements PipeTransform {

  constructor(private configService: ConfigurationService) {}
  
  transform(value: unknown, ...args: unknown[]): unknown {
    return this.configService.getAllStatesList().find(s => s.value === value)?.viewValue;
  }

}
